import {createContext} from 'react';
import { Page } from '../types/Page';

export type ListPagesContextType = {
    listPages: any | null;
    getAllPages: () => void;
    addPage: (e : Page) => void;
    removePage: (e : number) => void;
}
export const ListPagesContext = createContext<ListPagesContextType>(null!);